import { useBreakPoints, usePlatformService } from 'core/Hooks';

import { MobileHamburgerMenu } from './Menus/MobileMenu/MobileHamburgerMenu';

const HamburgerMenu = () => {
  const Platform = usePlatformService();
  const { isSmallScreen } = useBreakPoints();

  if (Platform.isNative || !isSmallScreen) {
    return null;
  }

  return <MobileHamburgerMenu />;
};

export { HamburgerMenu };
